<template>
    <div class="my-3 card card-body bg-dark text-light">
		<router-link to="/drl"><i class="fas fa-arrow-left"></i> Back</router-link>
        <h1 class="my-3 text-center">Các Bước lấy Token Code</h1>

        <div v-if="!$isMobile()">
			<div class="my-5">
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/drl/pcAccount0.png'" alt="TKB hust" />
				</div>
				<div class="row justify-content-center">
					<div>B1) Đăng nhập vào trang CTSV</div>
				</div>
			</div>

			<div class="my-5">
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/drl/pcAccount1.png'" alt="TKB hust" />
				</div>
				<div class="row justify-content-center">
					<div>B2) Nhấn URL và gõ "javascript:"</div>
				</div>
			</div>

			<div class="my-5">
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/drl/pcAccount2.png'" alt="TKB hust" />
				</div>
				<div class="row justify-content-center mb-3">
					<div>
						B3) Copy đoạn code bên dưới và dán vào URL sau "javascript:":
					</div>
				</div>
				<div class="row justify-content-center">
					<div>
						Nếu login bằng tài khoản <span class="text-danger">CTSV</span>:
						<span @click="copy(jsCodeForCTSV)" class="cursor-pointer">
							{{ jsCodeForCTSV }}
						</span>
						<span title="Copy">
							<i @click="copy(jsCodeForCTSV)" class="far fa-copy cursor-pointer ml-3"></i>
						</span>
					</div>
				</div>
				<div class="row justify-content-center">
					<div>
						Nếu login bằng tài khoản <span class="text-danger">Microsoft</span>:
						<span @click="copy(jsCodeForMicrosoft)" class="cursor-pointer">
							{{ jsCodeForMicrosoft }}
						</span>
						<span title="Copy">
							<i @click="copy(jsCodeForMicrosoft)" class="far fa-copy cursor-pointer ml-3"></i>
						</span>
					</div>
				</div>
			</div>

			<div class="my-5">
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/drl/pcAccount3.png'" alt="TKB hust" />
				</div>
				<div class="row justify-content-center">
					<div>B4) Nhấn Enter sẽ hiện ra Token Code</div>
				</div>
				<div class="row justify-content-center">
					<small class="text-warning">
						Lưu ý: Token Code của tài khoản Microsoft khá dài, bạn đang lấy đúng Code rồi
					</small>
				</div>
			</div>

			<div class="my-5">
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/drl/pcAccount5.png'" alt="TKB hust" />
				</div>
				<div class="row justify-content-center">
					<div>B5) Dán Token Code vừa lấy được vào ô "Token Code"</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="my-5">
				<div class="row justify-content-center mb-3">
					<small>
						B1) Sau khi Login, Copy đoạn code sau: <br>
					</small>
				</div>
				<div class="row justify-content-center">
					<div>Nếu login bằng tài khoản <span class="text-danger">CTSV</span></div>
				</div>
				<div class="row align-items-center">
					<div :class="{ 'dot-dot-dot': !mobileSeeMoreCode }" class="px-3 col-10" style="word-break: break-all;">
						<span @click="mobileSeeMoreCode = true" class="cursor-pointer">
							{{ jsCodeForCTSV }}
						</span>
					</div>
					<div class="col-1">
						<i @click="copy(jsCodeForCTSV)" class="far fa-copy cursor-pointer"></i>
					</div>
				</div>
				<div class="row justify-content-center">
					<div>Nếu login bằng tài khoản <span class="text-danger">Microsoft</span></div>
				</div>
				<div class="row align-items-center">
					<div :class="{ 'dot-dot-dot': !mobileSeeMoreCode }" class="px-3 col-10" style="word-break: break-all;">
						<span @click="mobileSeeMoreCode = true" class="cursor-pointer">
							{{ jsCodeForMicrosoft }}
						</span>
					</div>
					<div class="col-1">
						<i @click="copy(jsCodeForMicrosoft)" class="far fa-copy cursor-pointer"></i>
					</div>
				</div>
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/drl/mobileAccount0.jpg'" alt="TKB hust" />
				</div>
			</div>

			<div class="my-5">
				<div class="row justify-content-center">
					<small>B2) Sang trang CTSV, gõ "javascript:" vào URL</small>
				</div>
				<div class="row justify-content-center">
					<small class="text-warning">Lưu ý: phải gõ "javascript:" từ bàn phím</small>
				</div>
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/drl/mobileAccount1.jpg'" alt="TKB hust" />
				</div>
			</div>

			<div class="my-5">
				<div class="row justify-content-center">
					<small>B3) Dán đoạn code vừa Copy vào sau "javascript:"</small>
				</div>
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/drl/mobileAccount2.jpg'" alt="TKB hust" />
				</div>
			</div>

			<div class="my-5">
				<div class="row justify-content-center">
					<small>B4) Nhấn Enter sẽ hiện ra Token Code</small>
				</div>
				<div class="row justify-content-center">
					<small class="text-warning">Nếu không hiện, xin hãy thử dùng Chrome hoặc Cốc Cốc</small>
				</div>
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/drl/mobileAccount3.jpg'" alt="TKB hust" />
				</div>
			</div>

			<div class="my-5">
				<div class="row justify-content-center">
					<small>B6) Dán Token Code vừa lấy được vào ô "Token Code"</small>
				</div>
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/drl/mobileAccount5.jpg'" alt="TKB hust" />
				</div>
			</div>
		</div>
    </div>
</template>

<script>
import { contentHost } from '@/api/constant.js'
export default {
    data() {
        return {
            mobileSeeMoreCode: false,
            jsCodeForCTSV: "/TokenCode=([^;]+);/.exec(document.cookie)[1]",
			jsCodeForMicrosoft: "localStorage.getItem('adal.idtoken')",
			host: contentHost,
        }
    },
    methods:{
        copy(text){ // on mobile must have https
			if (navigator?.clipboard?.writeText) {

				navigator.clipboard.writeText(text)
				this.$toast.success('Đã copy!')
			} else {
				this.$toast.error('Trình duyệt của bạn không cho phép trang web này copy text!')
			}
        },
    }
}
</script>

<style scoped>
    .nav-link{
        color: white;
    }
</style>